import type { Strings } from './strings.js';

export const en: Strings = {
  languageName: 'English',
  welcome: 'Welcome',
  chooseReason: 'How can we help you?',
  back: 'Back',
  cancel: 'Cancel',
  next: 'Continue',
  submit: 'Send check-in',
  submitting: 'Sending',
  yourDetails: 'Your details',
  optional: 'optional',
  required: 'required',
  requiredHint: 'Please complete the highlighted fields.',
  fieldRequired: 'Please complete this field.',
  fieldInvalid: 'Please check this entry.',
  pleaseSelect: 'Please select',
  search: 'Search',
  noResults: 'No match',
  noOptions: 'There is nothing to choose from here at the moment. Please ask a member of staff.',
  stepReason: 'Reason',
  stepDetails: 'Details',
  stepDone: 'Done',
  thankYou: 'Thank you!',
  submitted: 'Your check-in has been submitted.',
  waitHint: 'Please take a seat. You will be called shortly.',
  scanFormHint: 'Scan the code with your phone to take the form with you.',
  ticketNumber: 'Your waiting number is',
  queuedTitle: 'Thank you!',
  queuedHint: 'Your check-in was saved and will be delivered automatically. Please take a seat.',
  errorTitle: 'That did not work',
  errorHint: 'Please try again or ask a member of staff.',
  tryAgain: 'Try again',
  startOver: 'Start over',
  closedTitle: 'Our office is currently closed',
  closedHint: 'You can still check in - we will get back to you on the next working day.',
  closedCallUs: 'You can reach us by phone at',
  continueAnyway: 'Check in anyway',
  appointmentQuestion: 'Do you have an appointment?',
  appointmentYes: 'Yes, I have an appointment',
  appointmentNo: 'No, I do not have an appointment',
  visitingWhom: 'Who are you visiting?',
  privacyTitle: 'Data protection',
  privacyAccept: 'I have read the privacy notice.',
  privacyRequired: 'Please confirm the privacy notice.',
  offline: 'Offline',
  offlineHint: 'No connection - check-ins are stored and submitted later.',
  pendingCount: 'stored check-in(s)',
  idleWarning: 'Your input will be discarded shortly.',
  pairTitle: 'Connect tablet',
  pairHint: 'Please enter the pairing code from the administration.',
  pairPlaceholder: 'ABCD-1234',
  pairButton: 'Connect',
  pairError: 'The code is invalid or has expired.',
  pairSuccess: 'Tablet connected',
  loading: 'Loading',
  notConfigured: 'No visitor types configured',
  notConfiguredHint: 'Please ask a member of staff.',
  adminLink: 'Administration',
  pairCodeHint:
    'The code is created in the administration under “Sites and tablets” and is only valid for a limited time.',
  setupTitle: 'Not set up yet',
  setupText:
    'This system has not been set up yet. The setup wizard creates the administrator, the organisation, a site and the first tablet.',
  setupButton: 'Start setup',
  setupAfter: 'The pairing code field appears here automatically once that is done.',
};
